import type { WidgetFilterConfig } from "./customDashboardTypes";

export interface FilterMeta {
  filterConfig: WidgetFilterConfig;
  defaultOffsetDays: number;
}

export function getFilterConfigForWidget(widgetKey: string): FilterMeta {
  const key = widgetKey.toLowerCase();

  if (key.includes("performance_analysis")) {
    return {
      filterConfig: { type: "date_range", useFacilityConfig: true, maxDays: 7 },
      defaultOffsetDays: 6,
    };
  }

  if (
    key.includes("battery_dispatch") ||
    key.includes("load_solar_utility") ||
    key.includes("demand_peaks") ||
    key.includes("demand_charge_cost")
  ) {
    return {
      filterConfig: { type: "date_range", useFacilityConfig: true, maxDays: 7 },
      defaultOffsetDays: 6,
    };
  }

  if (
    key.includes("_total") ||
    key.includes("total_") ||
    key.includes("_savings") ||
    key.includes("_cost") ||
    key.includes("_index") ||
    key.includes("kpi")
  ) {
    return {
      filterConfig: { type: "period", defaultValue: "24h" },
      defaultOffsetDays: 1,
    };
  }

  if (
    key.includes("overall_load_generation") ||
    key.includes("overall_usage")
  ) {
    return {
      filterConfig: { type: "period", defaultValue: "24h" },
      defaultOffsetDays: 1,
    };
  }

  if (key.includes("distribution")) {
    return {
      filterConfig: { type: "date_range_component_resolution" },
      defaultOffsetDays: 1,
    };
  }

  if (key.includes("pattern")) {
    return {
      filterConfig: {
        type: "date_range_component",
        useFacilityConfig: false,
        weekRange: true,
      },
      defaultOffsetDays: 6,
    };
  }

  if (key.includes("energy_analysis") && key.includes("profile")) {
    return {
      filterConfig: {
        type: "date_range",
        useFacilityConfig: false,
        weekRange: true,
        granularity: true,
      },
      defaultOffsetDays: 6,
    };
  }

  if (key.includes("advanced_energy")) {
    return {
      filterConfig: {
        type: "date_range",
        useFacilityConfig: true,
        maxDays: 7,
      },
      defaultOffsetDays: 6,
    };
  }

  if (key.includes("system_power_profile")) {
    return {
      filterConfig: { type: "date_multicomponent" },
      defaultOffsetDays: 0,
    };
  }

  if (key.includes("performance_metrics")) {
    return {
      filterConfig: { type: "period", defaultValue: "24h" },
      defaultOffsetDays: 1,
    };
  }

  if (
    key.includes("aggregated_savings") ||
    key.includes("dispatch_behavior") ||
    key.includes("operational_cost") ||
    key.includes("carbon_emissions") ||
    key.includes("resiliency_index") ||
    key.includes("rl_decisions")
  ) {
    return {
      filterConfig: { type: "date_range", useFacilityConfig: false },
      defaultOffsetDays: 6,
    };
  }

  return { filterConfig: { type: "none" }, defaultOffsetDays: 1 };
}
